module.exports = __webpack_public_path__ + "static/img/img27.6bcd93c3.png";